import { Location } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { LocationService } from "@obg/ngx.global";
import { Request } from "express";

import { REQUEST_TOKEN } from "../model";

@Injectable()
export class ServerLocationService implements LocationService {
	constructor(
		@Inject(REQUEST_TOKEN) public request: Request,
		private location: Location
	) {}

	getOrigin(): string {
		return `${this.request.protocol}://${this.request.headers.host}`;
	}

	getPath(): string {
		return this.request.path;
	}

	getHostName(): string {
		return this.request.hostname;
	}

	navigate(_url: string, _target?: string, _options?: string) {
		// noop
	}

	prepareExternalUrl(url: string): string {
		return this.location.prepareExternalUrl(url);
	}

	reload(_forcedReload?: boolean) {
		// noop
	}
}
